import { Add, Delete, Edit } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { RemoveRedEye } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, { useEffect, useState } from "react";
import { QueryClient, useMutation } from "react-query";
import Search from "components/Search/Search";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import DeleteModal from "components/UI/Form/partials/Delete";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import { addUser, deleteUser, editUser, getUsers, UsersCells } from "framework/user";
import phone from 'phone';
import AddModalReseller from "./partials/Add";
import EditModalReseller from "./partials/Edit";
import { formatDate } from "helpers";
import { IPolicy, IPolicyInput } from "models/policy";
import { useNavigate } from "react-router-dom";
import { addPolicy, deletePolicy, editPolicy, getPolicies, PoliciesCells } from "framework/policy";

interface Props {
  feature: Feature;
}


const Policies: React.FC<Props> = ({ feature }) => {

  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterPolicies, setFilterPolicies] = useState<IPolicy[]>([] as IPolicy[]);
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [SelectedPolicy, setSelectedPolicy] = useState<IPolicy | null>(null);
  const [inputObj, setInputObj] = useState<IPolicyInput>({} as IPolicyInput);
  const { setAlert } = useAlert();

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addUserMutation = useMutation({
    mutationFn: (createInput: IPolicyInput) => {
      return addPolicy(createInput);
    },
  });

  const editUserMutation = useMutation({
    mutationFn: (data: { createInput: IPolicyInput; resellerId: string }) => {
      return editPolicy(data.createInput, data.resellerId);
    },
  });

  const deleteUserMutation = useMutation({
    mutationFn: (id: string) => {
      return deletePolicy(id);
    },
  });

  const {
    loading,
    data: Policies,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getPolicies(),
    fetchPermission: async () => null,
    section: "Policies",
    onSuccess: (data) => setFilterPolicies(data),
  });


  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenAdd = () => {
    setOpenAdd(true);
    setInputObj((prev) => ({
      ...prev,
      CountryCode: '+971',
      dateOfBirth: new Date().toISOString()
    }));
  }

  const handleOpenEdit = (user: IPolicy) => {
    setSelectedPolicy(user);
    setOpenEdit(true);
  };

  const handleOpenDelete = (user: IPolicy) => {
    setSelectedPolicy(user);
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpenAdd(false)
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedPolicy(null);
    setInputObj({} as IPolicyInput)
  }

  const getBodyCells = (row: IPolicy) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "title")
        return {
          id: "title",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.title}</Typography>
            </TableCell>
          ),
        };
      if (key === "content")
        return {
          id: "content",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2"><div dangerouslySetInnerHTML={{ __html: row?.content }} /></Typography>
            </TableCell>
          ),
        };

      if (key === "type")
        return {
          id: "type",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.type}</Typography>
            </TableCell>
          ),
        };


      if (key === "id")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
              >

                <Tooltip title={"Edit"}>
                  <IconButton
                    size={"small"}
                    color={"primary"}
                    onClick={() => handleOpenEdit(row)}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>


                {/* <Tooltip title={"Delete"}>
                  <IconButton
                    size={"small"}
                    sx={{
                      color: "red",
                    }}
                    onClick={() => handleOpenDelete(row)}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip> */}


                {/* <Tooltip title={`Go to ${userId === '1' ? "User" : "Doctor"}`}>
                  <IconButton
                    size={"small"}
                    sx={{
                      color: "#9e9e52",
                    }}
                    onClick={() => navigate(`${row.userId}`)}
                  >
                    <RemoveRedEye />
                  </IconButton>
                </Tooltip> */}

              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };

  const handleAdd = async () => {


    // if (
    //   !isValidNumber(inputObj.countryCode + inputObj.contactNumber))


    //   return setAlert({
    //     open: true,
    //     message: "This Phone is not valid in this country",
    //     type: "error",
    //   });

    try {
      setLoading2(true);

      await addUserMutation.mutateAsync(inputObj);
      setAlert({
        open: true,
        message: `Policy added successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IPolicyInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEdit = async () => {


    // if (
    //   !isValidNumber((inputObj.countryCode || SelectedPolicy!?.contactNumber) + (inputObj.contactNumber || SelectedPolicy!?.contactNumber)))


    //   return setAlert({
    //     open: true,
    //     message: "This Phone is not valid in this country",
    //     type: "error",
    //   });

    let createInput: IPolicyInput = {
      ...SelectedPolicy,
      ...inputObj
    };
    try {
      setLoading2(true);
      await editUserMutation.mutateAsync({
        createInput,
        resellerId: SelectedPolicy!?.id?.toString()
      });



      setAlert({
        open: true,
        message: `Policy updated successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IPolicyInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteUserMutation.mutateAsync(SelectedPolicy!.id?.toString());
      setAlert({
        open: true,
        message: `Policy deleted successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleSearch = (value: string) => {
    if (!Policies) return;

    const searchTerm = value.trim().toLowerCase();

    if (!searchTerm) {
      setFilterPolicies(Policies);
      return;
    }

    const filtered = Policies.filter(({ content, title, type }) => {
      const fullText = `${content} ${title} ${type}`.toLowerCase();
      return fullText.includes(searchTerm);
    });

    setFilterPolicies(filtered);
  };


  let addBasicFields: IFormField[] = [
    {
      name: 'title',
      label: 'Title',
      type: InputTypes.TEXT,
      placeholder: 'Enter Title',
      internalLabel: true,
      required: true
    },
    {
      name: 'content',
      label: 'Content',
      type: InputTypes.TEXT,
      placeholder: 'Enter Content',
      internalLabel: true,
      required: true
    },
    {
      name: 'type',
      label: 'Type',
      type: InputTypes.TEXT,
      placeholder: 'Enter Type',
      internalLabel: true,
      required: true
    }
  ];


  let editBasicFields: IFormField[] = [
    {
      name: 'title',
      label: 'Title',
      type: InputTypes.TEXT,
      placeholder: 'Enter Title',
      defaultValue: SelectedPolicy?.title || '',
      internalLabel: true,
      required: true
    },
    {
      name: 'content',
      label: 'Content',
      type: InputTypes.EDITOR,
      placeholder: 'Enter Content',
      defaultValue: SelectedPolicy?.content || '',
      internalLabel: true,
      required: true
    },
    {
      name: 'type',
      label: 'Type',
      type: InputTypes.TEXT,
      placeholder: 'Enter Type',
      defaultValue: SelectedPolicy?.type || '',
      internalLabel: true,
      disabled: true,
      required: true
    }
  ];


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"

        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
            sx={{ mb: 4 }}
          >
            <Typography
              variant="h3"
              color={"header.primary"}
            >
              {(feature.name)}
            </Typography>

            {/* <Tooltip title={"Add"}>
              <IconButton
                sx={{
                  color: "black",
                  height: 40,
                  width: 40,
                  transition: "0.5s",
                }}
                onClick={handleOpenAdd}
              >
                <Add />
              </IconButton>
            </Tooltip> */}

          </Stack>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              direction={{ lg: "row", xs: "column" }}
              spacing={1}
              width={"100%"}
            >
              <Search handleChange={handleSearch} placeholder={"Search"} />
            </Stack>
          </Stack>
        </Grid>

        {FilterPolicies.length > 0 && (
          <List
            headCells={PoliciesCells}
            data={FilterPolicies}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}
        {(!FilterPolicies || FilterPolicies.length === 0) &&

          <EmptyContent
            icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
            header={"No Policies"}
            message={`No Policy Exists Yet`}
          />
        }


      </Stack>

      {openAdd && (
        <AddModalReseller
          open={openAdd}
          loading={loading2}
          disabled={!inputObj.title || !inputObj.content || !inputObj.type}
          title={`Add Policy`}
          basicFields={addBasicFields}
          onClose={handleClose}
          onSubmit={handleAdd}
          onChanges={handleChange}
        />
      )}
      {openEdit && (
        <EditModalReseller
          open={openEdit}
          loading={loading2}
          title={`Edit Policy`}
          policy={SelectedPolicy!}
          basicFields={editBasicFields}
          onClose={handleClose}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteModal
          open={openDelete}
          loading={loading2}
          title={`Delete Policy`}
          description={`Are You Sure You Want to delete this Policy`}
          onClose={handleClose}
          onSubmit={handleDelete}
        />
      )}
      {/* {openView && (
        <ViewClientsModal
          open={openView}
          title="View Client Subscriptions"
          feature={feature}
          onClose={handleClose}
        />
      )} */}
    </>
  );
};

export default Policies;
